import { useState } from "react";
import { Alert, Form, Input, Modal, message } from "antd";
import NewPasswordFields from "../NewPasswordFields";
import { changePassword } from "../../utils";
import { useSession } from "../../session/SessionContext";

interface Props {
  open: boolean;
  onClose(): void;
}

interface Values {
  currentPassword: string;
  password: string;
}

const ChangePasswordModal: React.FC<Props> = ({ open, onClose }) => {
  const [form] = Form.useForm<Values>();
  const { replaceToken } = useSession();
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async ({ currentPassword, password }: Values) => {
    setSubmitting(true);
    setError(null);
    try {
      const { token } = await changePassword(currentPassword, password);
      replaceToken(token);
      message.success("Password changed. Your other sessions have been signed out.");
      onClose();
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title="Change password"
      open={open}
      onCancel={onClose}
      onOk={() => form.submit()}
      okText="Change password"
      confirmLoading={submitting}
      destroyOnHidden
      afterClose={() => {
        form.resetFields();
        setError(null);
      }}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label="Current password"
          name="currentPassword"
          rules={[{ required: true, message: "Enter your current password" }]}
        >
          <Input.Password autoComplete="current-password" />
        </Form.Item>
        <NewPasswordFields />
        {error && <Alert type="error" title={error} />}
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal;
